import _ from 'lodash';
import { createSelector } from 'reselect';

const loginKey="loginState";

export const getLoginState = (state) => _.get(state, loginKey);
export const getUserContextData = createSelector(getLoginState, (state) => _.get(state, 'userContext'));
export const getForgotePasswordData = createSelector(getLoginState, (state) => _.get(state, 'forgotePassword'));
export const getUsernameSelector = createSelector(getLoginState, (state)=> _.get(state,'forgotUserName'))
export const getPortalVersionData = createSelector(getLoginState, (state)=> _.get(state,'portalVersionData'))
export const getCitationAppealDays = createSelector(getLoginState, (state)=> _.get(state,'citationAppleayDays'))
export const getKeyClockUser = createSelector(getLoginState, (state)=> _.get(state,'getKeycloakUsr'))


